import Resource from "./Resource";

export default class Resources {

    static make(namespace, resource_slug) {
        return new Resource(namespace, resource_slug);
    }

}